"use strict";

import app from "@/main";
import axios from "axios";
import {bildirimMetni} from "@/plugins/uyap-plugin/bildirimMetni";
import {apiYoluMu, istekSessizMi, lisansHatasiTuru} from "@/utils/istekPolitikasi";
import {imzaciSurumBasligi, imzaciSurumu, kabukBaslikDestegiVarMi} from "@/utils/imzaciSurumu";
import {tcknNormalize} from "@/store/oturumKimligi";

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.baseURL = "https://imza.eicrapro.com:6090/";
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';
let config = {
    baseURL: "https://imza.eicrapro.com:6090/"
    // timeout: 60 * 1000, // Timeout
    // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);
_axios.defaults.headers.common['Content-Type'] = "application/x-www-form-urlencoded";
_axios.interceptors.request.use(
    function (config) {
        // @ts-ignore
        // Do something before request is sent
        document.body.style.cursor = 'wait';
        // Kimlik: öneri sorgusunda config.kimlik, diğer her istekte AKTİF KİMLİK. Ham sessionStorage
        // anahtarları (setConfig'in öneri olarak yazdıkları) artık OKUNMAZ: tarayıcıda başka büroya
        // ya da hesaba geçmek çalışan botun kimliğini ortasında değiştiremesin.
        const kimlik = config.kimlik ?? app.$store.getters.aktifKimlik;
        if (kimlik && kimlik.token) {
            // @ts-ignore
            config.headers['Authorization'] = kimlik.token;
            if (kimlik.tenant_id) {
                // @ts-ignore
                config.headers['Tenant-Id'] = kimlik.tenant_id;
            }
        }
        // Sunucu denetimi için X-Imzaci-Tckn (UYAP oturumunun TCKN'si, biliniyorsa) ve
        // X-Imzaci-Surum. YALNIZ imzacı kabuğunun /api/ yoluna ve YALNIZ kabuk >= 2.0.5 iken:
        // eski kabukların CORS izin listesinde bu başlıklar yoktur ve tarayıcı ön kontrolde
        // TÜM /api isteklerini (next-task dahil) düşürür. Öneri sorgularına eklenmez.
        const kabukSurumu = window.zirvelib?.kabukSurumu;
        if (!config.kimlik && kabukBaslikDestegiVarMi(kabukSurumu) && apiYoluMu(config)) {
            const tckn = tcknNormalize(app.$store.state.uyapAvukatBilgileri?.tcKimlikNo);
            if (/^\d{11}$/.test(tckn)) {
                // @ts-ignore
                config.headers['X-Imzaci-Tckn'] = tckn;
            }
            // @ts-ignore
            config.headers['X-Imzaci-Surum'] = imzaciSurumBasligi(imzaciSurumu(), kabukSurumu);
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);


// Add a response interceptor
_axios.interceptors.response.use(
    function (response) {
        document.body.style.cursor = 'default';
        return response.data;
    },
    function (error) {
        document.body.style.cursor = 'default';
        const istek = error.config;
        // Arka plan istekleri (next-task, imzaci/kimlik, görev listesi) toast atmaz: sunucu/ağ
        // bozukken her 5 sn'de bir toast olurdu. Hata yine reject edilir; bölüm başına tek
        // bildirimi bot döngüsü verir.
        const toastAt = (metin: string) => {
            if (istekSessizMi(istek)) {
                console.warn('Arka plan isteği başarısız:', metin);
            } else {
                app.$toast.error(metin);
            }
        };

        // Check if response exists before accessing status
        if (error.response) {
            const durum = error.response.status;
            if (durum === 401) {
                const kullanilanToken = istek && istek.headers ? istek.headers['Authorization'] : undefined;
                // Öneri sorgusunun (config.kimlik) 401'i aktif kimliğe DOKUNMAZ: yalnız önerinin
                // token'ının geçersiz olduğunu söyler. Normal istekte, kullanılan token hâlâ aktif
                // token ise kimlik geçersiz sayılır: bot döngüsü ve UYAP girişi yeni kimlik
                // (updateToken) gelene kadar bekler. Eski token'la giden geç bir istek yok sayılır.
                if (!(istek && istek.kimlik)) {
                    app.$store.dispatch('kimlikTokeniGecersizBildir', {kullanilanToken});
                }
                // Ham anahtar yalnız 401 alan token'a eşitse silinir: tarayıcının bu arada yazdığı
                // yeni token silinmez.
                if (kullanilanToken && sessionStorage.getItem('accessToken') === kullanilanToken) {
                    sessionStorage.removeItem('accessToken');
                }
            }
            const lisansTuru = durum === 423 ? lisansHatasiTuru(error) : null;
            if (lisansTuru !== null) {
                // 423 imza/lisans denetimi: toast değil, engelleyici uyarı + bot duraklatma.
                const veri = error.response.data;
                app.$store.dispatch('kimlikUyusmazligiUyarisiGoster', {
                    sebep: lisansTuru,
                    mesaj: veri && typeof veri.message === 'string' ? veri.message : undefined
                });
            } else if (durum >= 400 && durum < 500) {
                toastAt(bildirimMetni(error));
            }
        } else if (error.request) {
            // Network error or connection refused
            console.warn('Network error:', error.message);
            if (error.code === 'ERR_CONNECTION_REFUSED') {
                toastAt('Bağlantı kurulamadı. Servisin çalıştığından emin olun.');
            } else {
                toastAt('Ağ hatası: ' + bildirimMetni(error));
            }
        } else {
            // Something else happened
            toastAt('Beklenmeyen hata: ' + bildirimMetni(error));
        }

        return Promise.reject(error);
    }
);

export function AxiosPlugin<AxiosPlugOptions>(Vue: any): void {
    // do stuff with options
    Vue.prototype.$http = _axios;
}

export class AxiosPluginOptions {
    // add stuff
}
